export const marketingCampaignsApiEndpoints = {
    MARKETING_CAMPAIGN: 'marketing-campaign',
};
